import React from 'react'
import TechnicalServicePage from '../components/TechnicalServicePage'

const GenomicsPage = () => {
  return <TechnicalServicePage serviceKey="genomics" />
}

export default GenomicsPage
